import { useSelector } from "react-redux";
import { RootState } from "@/store";

export const useFilterState = () => {
  return useSelector((state: RootState) => state.filterTax);
};
